/**
 * OpenAPI definition
 *
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { Pair } from './pair';

/**
 * Trade way for synthetic trading
 */
export interface TradeWay {
  pair1: Pair;
  side1: TradeWay.Side1Enum;
  pair2: Pair;
  side2: TradeWay.Side2Enum;
}
export namespace TradeWay {
  export const Side1Enum = {
    Buy: 'BUY',
    Sell: 'SELL',
  } as const;
  export type Side1Enum = (typeof Side1Enum)[keyof typeof Side1Enum];
  export const Side2Enum = {
    Buy: 'BUY',
    Sell: 'SELL',
  } as const;
  export type Side2Enum = (typeof Side2Enum)[keyof typeof Side2Enum];
}
